import INFO_01 from '../../../assets/images/feature/feature-noti-01.png';
import INFO_02 from '../../../assets/images/feature/feature-noti-02.png';
import DOC_GRAPH from '../../../assets/images/avartar/avatar-doc-graph@2x.png';
import DOC from '../../../assets/images/avartar/avatar-doc@2x.png';
import SHELID_CHECKED from '../../../assets/images/avartar/avatar-sheild-checked@2x.png';
import CALENDAR from '../../../assets/images/avartar/avatar-calendar@2x.png';
export default [
  {
    source: INFO_01,
    alt: '내가 입력한 정보 활용',
    title: '내가 입력한 정보 활용',
    subTitle: '번거로운 인증과 정보 입력 절차가 없어요',
  },
  {
    source: INFO_02,
    alt: '자동으로 가심사 진행',
    title: '자동으로 가심사 진행',
    subTitle: '내가 선택한 일자에 맞춰 가심사를 진행해 드려요',
  },
];

export const EXPLAIN = [
  {
    title: '나의 최저 금리, 최대 한도 상품 추천!',
    subTitle: '나의 최저 금리, 최대 한도 상품을 매월 받아보세요!',
    alt: '나의 최저 금리, 최대 한도 상품 추천!',
    source: DOC_GRAPH,
  },
  {
    title: '번거로운 정보입력은 그만!',
    subTitle: '자동으로 대출 심사를 진행해 결과를 알려드릴게요',
    alt: '번거로운 정보입력은 그만!',
    source: DOC,
  },
  {
    title: '신용 점수 떨어질 걱정은 그만!',
    subTitle: '자동으로 대출 심사를 받아도 점수에 영향이 없어요!',
    alt: '신용 점수 떨어질 걱정은 그만!',
    source: SHELID_CHECKED,
  },
  {
    title: '대출 승인도 빠르게!',
    subTitle: '대출 승인률이 높은 날에 알림을 보내드릴게요',
    alt: '대출 승인도 빠르게!',
    source: CALENDAR,
  },
];
